import { type ForwardedRef, forwardRef } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { EmptyFirstMissionWidget } from '@crehana/compass.dashlets';

type TEmptyFirstMissionWidgetProps = {
  organizationSlug: string;
  dataTestId?: string;
};

export const EmptyFirstMissionWidgetComponent = forwardRef<
  HTMLDivElement,
  TEmptyFirstMissionWidgetProps
>(({ organizationSlug, dataTestId }, ref: ForwardedRef<HTMLDivElement>) => {
  const { logEvent } = useAmplitude();

  const onNavigateToFirstMission = () => {
    logEvent({
      event: 'First Mission Action Clicked',
      data: {
        ...getSourceEventParams(),
        Organization: organizationSlug,
      },
    });
    const url = `/org/${encodeURIComponent(
      organizationSlug,
    )}/profile/my-profile/information`;
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <div ref={ref} data-testid={dataTestId} className="tw-w-full tw-h-full">
      <EmptyFirstMissionWidget
        onNavigateToFirstMission={onNavigateToFirstMission}
        size="m"
      />
    </div>
  );
});

EmptyFirstMissionWidgetComponent.displayName =
  'EmptyFirstMissionWidgetComponent';
